import { Component, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { DeviceDetectorService } from "src/services/device-detector.service";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent implements OnInit {
  color: boolean = false;

  constructor(
    private router : Router,
    private _deviceDetectorService : DeviceDetectorService,
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        let currentUrl = event.url;

        this.color = true;

        // this._deviceDetectorService.isMobileDevice() devuelve true si es un movil, false si no lo es. Ahora mismo desactiva todos los headers si detecta que es un movil
        if (!this._deviceDetectorService.isMobileDevice()){
          if (currentUrl === '/survey/results') {
            this.color = true;
          } else if (currentUrl === '/home' || currentUrl === '/'){
            this.color = true;
          } else if (currentUrl === '/users') {
            this.color = true;
          } else if (currentUrl === '/auth') {
            this.color = true;
          }
        }
        else {
          if (currentUrl === '/survey/results') {
            this.color = true;
          } else if (currentUrl === '/home' || currentUrl === '/'){
            this.color = true;
          } else if (currentUrl === '/auth') {
            this.color = true;
          }
        }
      }
    });
  }

  ngOnInit() {

  }
}
